import { useState } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Close, Visibility, VisibilityOff } from '@mui/icons-material';
import Promotion from '../../components/ReusableComponent/Promotion';
import { Checkbox, FormControlLabel } from '@mui/material';
import Login from './Login';
import { useDispatch, useSelector } from 'react-redux';
import { updateAuth } from '../../redux/authSlice';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: '#152234',
    boxShadow: 1,
    p: '36px 18px 40px 18px',
    color: '#FFF',
    borderRadius: '20px'
};



export default function Registration() {
    const [viewPwd, setViewPwd] = useState(false);
    const [registerForm, setRegisterForm] = useState({ phoneNumber: '', password: '' });
    const [formErrors, setFormErrors] = useState({});
    const openRegister = useSelector(state => state.auth.openRegister);
    const openLogin = useSelector(state => state.auth.openLogin);
    const dispatch = useDispatch();
    const handleClose = () => dispatch(updateAuth({ openRegister: false }));

    const togglePwdView = () => {
        setViewPwd(prev => !prev)
    }

    const onClickLogin = () => {
        dispatch(updateAuth({ openLogin: true }));
        dispatch(updateAuth({ openRegister: false }));
    }

    const onChangeFormDetails = (event) => {
        if (event.target.name === 'phone') {
            event.target.value = event.target.value.replace(/\D/g, '')
            setRegisterForm(prev => ({ ...prev, phoneNumber: event.target.value }));
        } else {
            setRegisterForm(prev => ({ ...prev, password: event.target.value }))
        }
        validateForm();
    }

    const validateForm = () => {
        const newErrors = {};
        if (!registerForm.phoneNumber.trim()) newErrors.phoneNumber = 'Phone Number is required';
        else if (!/^\d{9}$/.test(registerForm.phoneNumber)) newErrors.phoneNumber = 'Phone Number must be 10 digits';
        setFormErrors(newErrors);
        return Object.keys(newErrors)?.length === 0;
    };

    return (
        <div>
            <Modal
                open={openRegister}
                onClose={null}
                sx={{ backdropFilter: '#000c' }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style} className='w-11/12 md:w-[400px] box-border'>
                    <div className='register-head'>
                        <button className='absolute z-10 top-2 right-2' onClick={handleClose}>
                            <Close color='#FFF' />
                        </button>
                        <div className='text-2xl font-bold text-center'>
                            Registration
                        </div>
                    </div>
                    <div className='register-body mt-6'>
                        <Promotion />
                        <div className='mobile-input mt-6 w-full flex box-border font-semibold rounded-lg bg-[#1c2d4480]'>
                            <div className='country-code px-5 bg-[#1c2d4499] py-4 rounded-l-lg'>+91</div>
                            <input name='phone' minLength={10} maxLength={10} type="text" placeholder='Phone Number'
                                className='text-base px-5 w-full bg-transparent outline-none py-4' onChange={onChangeFormDetails} />
                        </div>
                        {formErrors.phoneNumber && <p className='text-red-500 text-sm'>{formErrors.phoneNumber}</p>}

                        <div className='pwd-input mt-6 w-full flex box-border font-semibold px-5 rounded-lg bg-[#1c2d4480]'>
                            <input name='password' type={viewPwd ? 'text' : 'password'} placeholder='Password'
                                className='text-base w-full bg-transparent outline-none py-4' onChange={onChangeFormDetails} />
                            <button onClick={togglePwdView}>
                                {viewPwd ? <Visibility /> : <VisibilityOff />}
                            </button>
                        </div>
                        {formErrors.password && <p className='text-red-500 text-sm'>{formErrors.password}</p>}

                        <div className='mt-6'>
                            <div className='ml-6'>
                                <FormControlLabel sx={{
                                    '& .MuiFormControlLabel-label': {
                                        fontSize: '14px',
                                    },
                                }} control={<Checkbox sx={{
                                    color: 'gray',
                                    '&.Mui-checked': { color: '#43CF7C' },
                                }} />} label="I have confirmed the phone number filled in is correct, and cannot be changed after registration." />
                            </div>
                        </div>
                        <div className='mt-8 font-bold'>
                            <button className='py-5 w-full text-center bg-cnf-btn rounded-lg text-base'>Confirm Registration</button>
                        </div>
                        <div className='mt-6 text-sm text-center'>
                            <div>Have an account?</div>
                            <button className='font-bold text-[#3dbefd]' onClick={onClickLogin}>Login</button>
                        </div>
                    </div>
                </Box>
            </Modal>
            {openLogin && <Login />}
        </div>
    );
}
